import { createQuoteLogic } from './createQuoteLogic';

export const logic = [createQuoteLogic];
